import angular from 'angular';
import FeaturedProductsComponent from './featured-products.component';

let FeaturedProductsModule = angular.module('catalog.featuredProducts', [])
  .component('featuredProducts', FeaturedProductsComponent);

export default FeaturedProductsModule;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/featured-products/featured-products.js
 **/